import { render } from "./TypeListDialog.vue?vue&type=template&id=fb99b54a"
import script from "./TypeListDialog.vue?vue&type=script&lang=js"
export * from "./TypeListDialog.vue?vue&type=script&lang=js"

import exportComponent from "D:\\yiban\\WebProject\\yimeng-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__